import { routeLinks } from "constants/paths";
import {
  ButtonLink,
  ErrorHeading,
  ErrorMessage,
  PageNotFoundContainer,
} from "./Styled";

export const SomethingWentWrong = () => {
  return (
    <PageNotFoundContainer>
      <ErrorHeading variant="h2">500 - Something went wrong.</ErrorHeading>
      <ErrorMessage variant="body1">Contact your administrator.</ErrorMessage>
      <ButtonLink variant="contained" href={routeLinks.dashboardCommon}>
        Return to Homepage
      </ButtonLink>
    </PageNotFoundContainer>
  );
};
